import ChevronDown from "@/assets/images/icons/chevron-down.svg";
import { Popover } from "@/components/ui/Popover";
import { BRAND_COLORS } from "@/lib/brandColors";
import { DASHBOARD_TOOLBAR_CONTROL_HEIGHT } from "@/lib/dashboardToolbarUi";
import React from "react";
import { Pressable, Text } from "react-native";

type DashboardToolbarDropdownProps = {
  label: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  width: number;
  content: React.ReactNode;
  accessibilityLabel?: string;
};

export function DashboardToolbarDropdown({
  label,
  open,
  onOpenChange,
  width,
  content,
  accessibilityLabel,
}: DashboardToolbarDropdownProps) {
  return (
    <Popover
      placement="bottom-start"
      open={open}
      onOpenChange={onOpenChange}
      offset={8}
      width={width}
      maxWidth={width}
      stayInFrame={false}
      allowFlip={false}
      content={content}
    >
      <Pressable
        onPress={() => onOpenChange(!open)}
        accessibilityRole="button"
        accessibilityLabel={accessibilityLabel ?? label}
        style={({ pressed }) => ({
          width,
          height: DASHBOARD_TOOLBAR_CONTROL_HEIGHT,
          borderRadius: DASHBOARD_TOOLBAR_CONTROL_HEIGHT / 2,
          backgroundColor: pressed ? "#EEEAE4" : "white",
          borderWidth: 1,
          borderColor: BRAND_COLORS.border,
          paddingHorizontal: 12,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 6,
          flexShrink: 0,
        })}
      >
        <Text
          numberOfLines={1}
          ellipsizeMode="tail"
          style={{
            fontSize: 14,
            fontWeight: "600",
            color: BRAND_COLORS.muted,
            flexShrink: 1,
            lineHeight: 18,
          }}
        >
          {label}
        </Text>
        <ChevronDown width={16} height={16} rotation={open ? 180 : 0} />
      </Pressable>
    </Popover>
  );
}
